import { RHFTextField } from 'src/components/hook-form';
export default function ActivityFirstRow({
  isDetailedResource,
  // unit calculations
  calculationofLaborCost,
  calculationofMaterialCost,
  calculationofEquipmentCost,
  calculationofSubcontractorCost,
  showUnitFields,
  // detail calculations
  showDetailFields,
  calculationofWorkdays,
  // unit calculations && detail calculations
  isUnitAndDetailSetting,
  calculationofLaborUnitPrice,
  // base calculations
  calculationofDirectUnitPrice,
  calculationofMarkupBidUnitPrice,
  calculationofDirectCostInSimpleResource,
}) {
  return (
    <>
      <RHFTextField name="activity" required label="Cost Code Activity" />
      <RHFTextField name="description" required label="Cost Code Activity Description" />
      <RHFTextField
        onChange={(e) => {
          if (isDetailedResource) {
            if (showUnitFields) {
              calculationofLaborCost(e.target.value, 'quantity');
              calculationofMaterialCost(e.target.value, 'quantity');
              calculationofEquipmentCost(e.target.value, 'quantity');
              calculationofSubcontractorCost(e.target.value, 'quantity');
            } else if (showDetailFields) {
              calculationofWorkdays(e.target.value, 'quantity');
            }
            if (isUnitAndDetailSetting) {
              calculationofLaborUnitPrice(e.target.value, 'quantity');
            }
            calculationofDirectUnitPrice(e.target.value, 'quantity');
          } else {
            calculationofDirectCostInSimpleResource(e.target.value, 'quantity');
          }

          calculationofMarkupBidUnitPrice(e.target.value, 'quantity');
        }}
        type="number"
        name="quantity"
        required
        label="Quantity"
      />
      <RHFTextField name="unit" required label="Unit" />
    </>
  );
}
